import type { Names, Round } from '../../types';

/** Canonical UI labels for sides; not user-editable. */
export enum TeamDisplayName {
  Team1 = 'Team 1',
  Team2 = 'Team 2',
}

export const BAGS_PER_TEAM = 8;

export const possibleBids = [
  'Blind Nil',
  'Nil',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
] as const;

export const possibleActuals = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
] as const;

export const initialNames: Names = {
  t1p1Name: '',
  t1p2Name: '',
  t2p1Name: '',
  t2p2Name: '',
  team1Name: TeamDisplayName.Team1,
  team2Name: TeamDisplayName.Team2,
};

export function normalizeNames(names: Names): Names {
  return {
    ...names,
    team1Name: TeamDisplayName.Team1,
    team2Name: TeamDisplayName.Team2,
  };
}

export const EMPTY_ROUND: Round = {
  team1BidsAndActuals: {
    p1Bid: '',
    p2Bid: '',
    p1Actual: '',
    p2Actual: '',
  },
  team2BidsAndActuals: {
    p1Bid: '',
    p2Bid: '',
    p1Actual: '',
    p2Actual: '',
  },
  dealerOverride: null,
  autoGeneratedActuals: {
    team1P1: false,
    team1P2: false,
    team2P1: false,
    team2P2: false,
  },
};

export const BLIND_NIL = 'Blind Nil';
export const NIL = 'Nil';
export const TEAM1 = 'team1BidsAndActuals';
export const TEAM2 = 'team2BidsAndActuals';
export const TAKES_BAGS = 'takesBags';
export const HELPS_TEAM_BID = 'helpsTeamBid';
export const NO_BAGS_NO_HELP = 'noBagsNoHelp';

const t1p1ID = 'team1BidsAndActuals.p1Bid';
const t1p2ID = 'team1BidsAndActuals.p2Bid';
const t2p1ID = 'team2BidsAndActuals.p1Bid';
const t2p2ID = 'team2BidsAndActuals.p2Bid';
export const initialFirstDealerOrder = [t1p1ID, t2p1ID, t1p2ID, t2p2ID];

export const team1Styles = {
  color: 'var(--app-team1)',
  borderColor: 'var(--app-team1)',
} as const;
export const team2Styles = {
  color: 'var(--app-team2)',
  borderColor: 'var(--app-team2)',
} as const;
